document.addEventListener("DOMContentLoaded", () => {
  const carousels = document.querySelectorAll(".video-carousel-block");

  const isMobile = () => window.innerWidth < 768;

  carousels.forEach((carousel, index) => {
    const swiper = new Swiper(carousel, {
      slidesPerView: "auto",
      spaceBetween: 5,
      loop: true,
      a11y: {
        enabled: true,
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
        firstSlideMessage: "This is the first slide",
        lastSlideMessage: "This is the last slide",
        paginationBulletMessage: "Go to slide {{index}}",
      },
      keyboard: { enabled: true, onlyInViewport: true },
      mousewheel: { forceToAxis: true },
      navigation: {
        nextEl: carousel.querySelector(".video-block-button-next"),
        prevEl: carousel.querySelector(".video-block-button-prev"),
      },
      pagination: {
        el: carousel.querySelector(".swiper-pagination"),
        clickable: true,
      },
      breakpoints: {
        0: { slidesPerView: "auto", spaceBetween: 5 },
        768: { slidesPerView: "auto" },
        1024: { slidesPerView: "auto" },
      },
      on: {
        init() {
          playActiveVideo(this);
        },
        slideChange() {
          playActiveVideo(this);
        },
      },
    });

    // 🔹 Play only active video
    function playActiveVideo(swiper) {
      swiper.slides.forEach((slide) => {
        const video = slide.querySelector("video");
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });

      const activeVideo = swiper.slides[swiper.activeIndex]?.querySelector("video");
      if (activeVideo) {
        activeVideo.play().catch(() => {});
        activeVideo.onended = () =>
          swiper.activeIndex < swiper.slides.length - 1
            ? swiper.slideNext()
            : swiper.slideTo(0);
      }
    }

    // 🔹 Modal setup
    const modal = document.querySelector(".video-carousel-block-modal");
    if (!modal) return;

    const modalVideo = modal.querySelector("video");
    const modalClose = modal.querySelector(".video-carousel-block-modal__close");
    const modalProduct = modal.querySelector(".video-carousel-block-modal__product");
    const modalToggleProduct = modal.querySelector(".video-carousel-block-modal__toggle-product-btn");

    // Open modal (mobile only)
    carousel.querySelectorAll(".video-carousel-block__video").forEach((videoEl) => {
      videoEl.addEventListener("click", (e) => {
        if (!isMobile()) {
          e.preventDefault();
          document.querySelector(".shopify-product-form")?.scrollIntoView({ behavior: "smooth", block: "center" });
          return;
        }

        e.preventDefault();
        const slide = videoEl.closest(".swiper-slide");
        const productInfo = slide.querySelector(".video-carousel-block__product-info")?.innerHTML || "";
        modal._allSlides = [...carousel.querySelectorAll(".swiper-slide")];
        modal._currentIndex = modal._allSlides.indexOf(slide);

        modalVideo.src = videoEl.src;
        modalVideo.poster = videoEl.poster;
        modalProduct.innerHTML = productInfo;

        modal.classList.add("active");
        document.body.classList.add("modal-open");

        modalVideo.currentTime = 0;
        // modalVideo.muted = false;
        modalVideo.play().catch(() => {});
      });
    });

    // 🔹 Swipe navigation inside modal
    let touchStartY = 0;
    modal.addEventListener("touchstart", (e) => (touchStartY = e.touches[0].clientY));
    modal.addEventListener("touchend", (e) => {
      if (!isMobile() || !modal.classList.contains("active")) return;
      const deltaY = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(deltaY) > 50) showModalVideoByIndex(modal._currentIndex + (deltaY > 0 ? 1 : -1));
    });

    function showModalVideoByIndex(idx) {
      const slides = modal._allSlides || [];
      if (idx < 0 || idx >= slides.length) return;

      const slide = slides[idx];
      const videoEl = slide.querySelector("video");
      const productInfo = slide.querySelector(".video-carousel-block__product-info")?.innerHTML || "";

      modal._currentIndex = idx;
      modalVideo.pause();
      modalVideo.src = videoEl?.src || "";
      modalVideo.poster = videoEl?.poster || "";
      modalProduct.innerHTML = productInfo;

      modalVideo.load();
      modalVideo.play().catch(() => {});
    }

    // 🔹 Close modal
    function closeModal() {
      modal.classList.remove("active");
      document.body.classList.remove("modal-open");
      modalVideo.pause();
      modalVideo.src = "";
    }
    modalClose?.addEventListener("click", closeModal);
    modal.addEventListener("click", (e) => e.target === modal && closeModal());

    // 🔹 Product toggle
    modalToggleProduct?.addEventListener("click", () => {
      modalProduct.classList.toggle("hidden");
      modalToggleProduct.classList.toggle("rotated");
      modalToggleProduct.setAttribute(
        "aria-label",
        modalProduct.classList.contains("hidden") ? "Show Product Details" : "Hide Product Details"
      );
    });
  });

  // 🔹 Global mute toggles
  document.querySelectorAll(".video-block-mute .mute-toggle-block").forEach((button) => {
    const video = button.closest(".video-block-mute")?.querySelector("video");
    const mutedIcon = button.querySelector(".icon-muted-block");
    const unmutedIcon = button.querySelector(".icon-unmuted-block");

    button.addEventListener("click", () => {
      video.muted = !video.muted;
      mutedIcon.style.display = video.muted ? "inline-flex" : "none";
      unmutedIcon.style.display = video.muted ? "none" : "inline-flex";
    });
  });
});
